import * as React from 'react';

var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SvgOrderTrackingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#828282",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.038,
    y: 36.037,
    width: 11,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.76 9H9.08c-.709.1-1.181.595-1.063 1.092.118.595.709.992 1.3.893h7.442c.472 0 .827-.199 1.063-.496a.783.783 0 000-.993C17.705 9.198 17.233 9 16.76 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.609 39.346l-5.56-5.637c2.664-3.221 2.316-7.938-.58-10.815a7.187 7.187 0 00-3.823-1.955V5.868c0-.23-.116-.346-.232-.576L22.823.46C22.59.23 22.243 0 21.78 0H4.634c-.348.115-.58.23-.81.46L.347 5.062s0 .115-.116.115c0 .115-.116.115-.116.115 0 .115-.116.115-.116.115v24.505c0 .69.58 1.15 1.159 1.15h16.566c.348.921.811 1.842 1.506 2.647 2.665 3.221 7.299 3.681 10.543 1.265l5.56 5.638c.232.345.58.46.927.345a1.04 1.04 0 00.696-.69c.115-.346 0-.69-.348-.92zM13.902 2.416h7.299l1.853 2.416h-9.152V2.416zm-8.457 0h7.299v2.416H3.59l1.854-2.416zm11.933 26.23H2.433V7.134h21.78v13.576a8.227 8.227 0 00-4.402 2.07c-1.622 1.611-2.433 3.797-2.433 5.868zm12.178 3.601l-1.132 1.125c-2.38 1.8-5.777 1.35-7.703-1.013-1.926-2.362-1.7-5.736.453-7.874a5.533 5.533 0 017.703-.112c2.152 2.025 2.605 5.512.68 7.874z"
  }))));
}

export { SvgOrderTrackingIcon as default };
